import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { connect } from 'react-redux';
import {
  reduxForm, Field, change, getFormValues,
} from 'redux-form';
import {
  MDBDropdown,
} from 'mdbreact';
import Modal from 'react-modal';
import { routes } from '../../utils/constants';
import Column from '../ReactComponent/Column';
import RenderField from '../ReactComponent/RenderField';
import Row from '../ReactComponent/Row';
import Actions from '../../assets/icons/Actions.svg';
import EditBlack from '../../assets/icons/EditBlack.svg';
import DeleteBlack from '../../assets/icons/DeleteBlack.svg';
import CreateAShipmentToBlack from '../../assets/icons/CreateAShipmentToBlack.svg';
import CreateAShipmentFromBlack from '../../assets/icons/CreateAShipmentFromBlack.svg';
import CreateAQuoteToBlack from '../../assets/icons/CreateAQuoteToBlack.svg';
import CreateAQuoteFromBlack from '../../assets/icons/CreateAQuoteFromBlack.svg';
import PlusBlack from '../../assets/icons/PlusBlack.svg';
import RemoveBlack from '../../assets/icons/RemoveBlack.svg';
import FilterBlack_v2 from '../../assets/icons/FilterBlack_v2.svg';
import SortBlack from '../../assets/icons/SortBlack.svg';
import Reset from '../../assets/icons/Reset.svg';
import CreateAShipmentToGrey from '../../assets/icons/CreateAShipmentToGrey.svg';
import CreateAShipmentFromGrey from '../../assets/icons/CreateAShipmentFromGrey.svg';
import CreateAQuoteToGrey from '../../assets/icons/CreateAQuoteToGrey.svg';
import CreateAQuoteFromGrey from '../../assets/icons/CreateAQuoteFromGrey.svg';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import { colors } from '../../theme/style-helpers';
import {
  FilterContainer,
  PageDescription,
  ModalDeleteHeader,
  ModalBody,
  ButtonGroup,
  SuccessDeleteMessage,
  ActionsContainer,
  FiltersAndTableContainer,
  TableContainer,
  PaginationContainer,
  DropdownItem,
  BoxContainer,
  BoxInfo,
  CategoryContainer,
  SubTitle,
  Title,
  TitlesContainer,
  ManageContactsForm,
  PageTitleH1,
  SearchContainer,
  SearchLabel,
  FilterCategoryTitle,
  CloseButton,
} from './css';
import { Icon as CommonIcon } from '../ReactComponent/Icon';
import { DropdownItemIcon } from '../ReactComponent/SortableTable/css';
import putReduxAllContacts from './actions';
import {
  homeUrlNoTrailingSlash,
  openInNewTab,
} from '../../utils/func';
import { getCompaniesList } from '../../services/companies';
import { getCompanyContacts, deleteContactByIds } from '../../services/contacts';
import { putReduxAllCompanies } from '../ManageCompanies/actions';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';
import SortableTableStyled from '../ReactComponent/SortableTableStyled';
import NoDataDecorator from '../ReactComponent/SortableTableStyled/NoDataDecorator';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import { AddressTypes } from '../../utils/enums';
import { MDBDropdownToggle, StyledMDBDropdownMenu } from '../_styledComponents/MDBDropdownToggle';
import TertiaryButton from '../../lib/ui/buttons/TertiaryButton';
import TextInput from '../../lib/ui/form_elements/TextInput';
import Search from '../../assets/icons/Search.svg';
import Dropdown from '../../lib/ui/form_elements/Dropdown';
import LeftSideBar from '../ReactComponent/LeftSideBar';
import Checkbox from '../../lib/ui/form_elements/Checkbox';
import XIcon from '../../assets/icons/x_icon.svg';

const formName = 'ManageContacts';

const BOX_CONTAINER_MAX_WIDTH = '347px';
const BOX_CONTAINER_MAX_HEIGHT = '226px';

const onClickUrl = (url) => () => openInNewTab(url);

const CustomDropdown = ({
  // eslint-disable-next-line no-unused-vars
  openModal, contactId, contactNickname, contactType,
}) => (
  <MDBDropdown className="dropdown">
    <MDBDropdownToggle className="border-0">
      <CommonIcon iconSrc={Actions} />
    </MDBDropdownToggle>
    <StyledMDBDropdownMenu className="text-white bg-dark" basic>
      <DropdownItem onClick={() => {
        window.location.href = (`${routes.createContact}?contactId=${contactId}`);
        return window.location.href;
      }}
      >
        <DropdownItemIcon iconSrc={EditBlack} className="button-dropdown" />
        <p>{t('EditContact')}</p>
      </DropdownItem>
      <DropdownItem
        disabled={contactType === AddressTypes.SHIPPER}
        onClick={() => {
          window.location.href = (`${routes.createQuote}?${AddressTypes.CONSIGNEE}=${contactId}`);
          return window.location.href;
        }}
      >
        <DropdownItemIcon className="button-dropdown" iconSrc={contactType === AddressTypes.SHIPPER ? CreateAQuoteToGrey : CreateAQuoteToBlack} />
        <p>
          {t('RequestAQuote')}
          {' '}
          {`(${t('To')})`}
        </p>
      </DropdownItem>
      <DropdownItem
        disabled={contactType === AddressTypes.CONSIGNEE}
        onClick={() => {
          window.location.href = (`${routes.createQuote}?${AddressTypes.SHIPPER}=${contactId}`);
          return window.location.href;
        }}
      >
        <DropdownItemIcon
          className="button-dropdown"
          iconSrc={contactType === AddressTypes.CONSIGNEE ? CreateAQuoteFromGrey : CreateAQuoteFromBlack}
        />
        <p>
          {t('RequestAQuote')}
          {' '}
          {`(${t('From')})`}
        </p>
      </DropdownItem>
      <DropdownItem
        disabled={contactType === AddressTypes.SHIPPER}
        onClick={() => {
          window.location.href = (`${routes.createShipment}?${AddressTypes.CONSIGNEE}=${contactId}`);
          return window.location.href;
        }}
      >
        <DropdownItemIcon
          className="button-dropdown"
          iconSrc={contactType === AddressTypes.SHIPPER ? CreateAShipmentToGrey : CreateAShipmentToBlack}
        />
        <p>
          {t('RequestAShipment')}
          {' '}
          {`(${t('To')})`}
        </p>
      </DropdownItem>
      <DropdownItem
        disabled={contactType === AddressTypes.CONSIGNEE}
        onClick={() => {
          window.location.href = (`${routes.createShipment}?${AddressTypes.SHIPPER}=${contactId}`);
          return window.location.href;
        }}
      >
        <DropdownItemIcon
          className="button-dropdown"
          iconSrc={contactType === AddressTypes.CONSIGNEE ? CreateAShipmentFromGrey : CreateAShipmentFromBlack}
        />
        <p>
          {t('RequestAShipment')}
          {' '}
          {`(${t('From')})`}
        </p>
      </DropdownItem>
      <DropdownItem onClick={() => openModal(contactId)}>
        <DropdownItemIcon className="button-dropdown" iconSrc={DeleteBlack} />
        <p>{t('DeleteContact')}</p>
      </DropdownItem>
    </StyledMDBDropdownMenu>
  </MDBDropdown>
);

export const ModalContent = ({ closeModal, handleDelete }) => (
  <>

    <TitlesContainer>
      <Title>{t('DeleteContact')}</Title>
      <SubTitle>{t('DeleteContactPrompt')}</SubTitle>
    </TitlesContainer>
    <ButtonGroup className="space-between">
      <SecondaryButton
        label={t('Cancel')}
        onClick={() => closeModal()}
        showArrow={false}
      />
      <PrimaryButton
        label={t('RemoveContact')}
        onClick={() => handleDelete()}
      />
    </ButtonGroup>
  </>
);

class ManageContacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      columns: [
        {
          id: 1,
          field: 'check',
          sort: false,
          selected: true,
          default: true,
        },
        {
          id: 2,
          label: 'Action',
          field: 'actions',
          sort: false,
          selected: true,
          default: true,
        },
        {
          id: 3,
          label: 'Nickname',
          field: 'nickname',
          sort: true,
          selected: true,
          default: true,
        },
        {
          id: 4,
          label: 'FullName',
          field: 'fullName',
          sort: true,
          selected: true,
          default: true,
        },
        {
          id: 5,
          label: 'Company',
          field: 'company',
          sort: true,
          selected: true,
          default: true,
        },
        {
          id: 6,
          label: 'lblContactType',
          field: 'contactType',
          sort: true,
          selected: true,
          default: true,
        },
        {
          id: 7,
          label: 'MoreDetails',
          field: 'moreDetails',
          sort: false,
          selected: false,
          default: false,
        },
      ],
      companies: [],
      modalIsOpen: false,
      filterOpen: false,
      deleteSuccess: false,
      success: 0,
      fail: 0,
      contactTypes: [],
      globalFilterValue: '',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchCompaniesAssociatedToUser();
    }, 200);
  }

  fetchCompaniesAssociatedToUser = async () => {
    const { division, userId, putReduxAllCompanies } = this.props;
    const { data: companies } = await getCompaniesList(division, userId);
    if (companies) {
      putReduxAllCompanies(companies);
      this.setState({ companies });
      this.handleCompanySelect(companies[0].companyId);
    }
  };

  getContactTypes = () => {
    const { allContacts, dispatch } = this.props;
    const uniqueContactTypes = allContacts.map((c) => c.contactType).filter((value, index, self) => (self.indexOf(value) === index));
    const uniqueTypes = [];
    uniqueContactTypes.map((item) => uniqueTypes.push(t(item.toLowerCase())));
    this.setState({ contactTypes: uniqueTypes });
    dispatch(change(formName, 'filterContactType', uniqueTypes));
  };

  handleCompanySelect = async (newValue) => {
    const { dispatch, putReduxAllContacts } = this.props;
    const { companies } = this.state;

    dispatch(change(formName, 'selectedCompany', newValue));

    if (companies) {
      const selectedCompany = companies.find(
        (company) => company.companyId === newValue,
      );
      const { companyId, companyName } = selectedCompany;
      const { data: companyContacts } = await getCompanyContacts(companyId);

      if (companyContacts) {
        const convertedContactData = this.convertDataFormat(
          companyContacts,
          companyName,
        );
        putReduxAllContacts(convertedContactData);
        this.setState({ data: convertedContactData });
        this.getContactTypes();
      }
    }
  };

  handleImportExportContact = (e) => {
    e.preventDefault();
    const createImportExportURL = `${homeUrlNoTrailingSlash()}${routes.importExport}`;
    openInNewTab(createImportExportURL);
  };

  renderHeader = ({ heading, description }) => (
    <Row style={{ margin: '0 0 32px' }}>
      <Column $tablet={8} $mobile={12} style={{ padding: '0' }}>
        <div>
          <PageTitleH1>{heading}</PageTitleH1>
          <PageDescription>{description}</PageDescription>
        </div>
      </Column>
    </Row>
  );

  handleDelete = async (contactId) => {
    const { formData: { checked, selectedCompany }, allContacts, dispatch } = this.props;
    this.openModal(contactId);
    const contactIds = contactId || (checked ? allContacts.filter((c, index) => {
      const checkbox = checked[index];
      return checkbox && checkbox[1];
    }).map((c) => c.contactId) : []);
    deleteContactByIds(contactIds)
      .then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          this.handleCompanySelect(selectedCompany);
          dispatch(change(formName, 'checked', []));
          dispatch(change(formName, 'checkAll', ['']));
          const successCount = data.filter((c) => c.statusCode === 200).length;
          const failCount = data.length - successCount;
          this.setState({ deleteSuccess: true, success: successCount, fail: failCount }, () => {
            setTimeout(() => { this.setState({ deleteSuccess: false }); }, 10000);
          });
        }
      });
    this.closeModal();
  };

  convertDataFormat = (companyContacts, companyName) => companyContacts.map((each, index) => ({
    check: (
      <Field
        name={`checked[${index}]`}
        type="checkboxes"
        multiple
        data={[' ']}
        component={RenderField}
      />
    ),
    actions: (
      <CustomDropdown
        openModal={(contactId) => this.openModal(contactId)}
        index={index}
        contactType={each.contactType.toLowerCase()}
        contactId={each.contactId}
        contactNickname={each.nickname}
      />
    ),
    nickname: each.nickname || 'N/A',
    fullName: each.contactName || 'N/A',
    company: each.companyName || companyName || 'N/A',
    contactType: t(each.contactType.toLowerCase()) || 'N/A',
    moreDetails:
  <>
    <Row>
      {each.email}
    </Row>
    <Row>
      {`${each.address1}${each.address2
        ? (` ${each.address2}`)
        : ''}, ${each.city}, ${each.provinceCode} ${each.postalCode}, ${each.countryCode}`}
    </Row>
  </>,
    contactId: each.contactId,
    email: each.email,
    address1: each.address1,
    address2: each.address2,
    city: each.city,
    provinceCode: each.provinceCode,
    postalCode: each.postalCode,
    countryCode: each.countryCode,
  }));

  openModal = (contactId) => {
    this.setState({
      modalIsOpen: true,
      contactToDelete: contactId,
    });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      contactToDelete: null,
    });
  };

  toggleFilter = () => {
    const { filterOpen } = this.state;
    this.setState({ filterOpen: !filterOpen });
  };

  applyFrontFilters = () => {
    const { dispatch, allContacts, formData: { filterContactType = [] } } = this.props;
    dispatch(change(formName, 'searchByKey', ''));
    let filteredData = [];

    if (filterContactType) {
      filterContactType.forEach((type) => {
        filteredData = filteredData.concat(allContacts.filter((s) => s.contactType === type));
        filteredData = filteredData.filter((value, index, self) => (self.indexOf(value) === index));
      });
    }

    this.setState({ data: filteredData });
  };

  handleSubmitFilter = () => {
    this.applyFrontFilters();
    this.toggleFilter();
  };

  resetFilters = () => {
    const { dispatch } = this.props;
    const { contactTypes } = this.state;
    dispatch(change(formName, 'filterContactType', contactTypes));
    this.setState({ data: [] }, () => this.applyFrontFilters());
  };

  getSuggestions = (value) => {
    const { allContacts, dispatch } = this.props;
    dispatch(change(formName, 'checked', []));
    dispatch(change(formName, 'checkAll', ['']));
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const filteredData = inputLength === 0
      ? allContacts
      : allContacts.filter(
        (item) => {
          // eslint-disable-next-line max-len
          const serializedrow = `${item.nickname} ${item.fullName} ${item.company} ${item.contactType} ${item.email} ${item.address1} ${item.address2 ? item.address2 : ''} ${item.city} ${item.provinceCode} ${item.postalCode} ${item.countryCode}`.toLowerCase();
          return serializedrow.indexOf(inputValue) > -1;
        });
    this.setState({ data: filteredData });
  };

  render() {
    const {
      rendering: {
        fields: { heading, description },
      },
      formData,
      dispatch,
    } = this.props;
    const {
      data,
      modalIsOpen,
      companies = [],
      filterOpen,
      deleteSuccess,
      success,
      fail,
      contactToDelete,
      columns,
      contactTypes,
      globalFilterValue,
    } = this.state;
    return (
      <ManageContactsForm>
        <Modal
          isOpen={modalIsOpen}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <ModalDeleteHeader>
            <CloseButton onClick={() => this.closeModal()}>
              <object type="image/svg+xml" data={XIcon} aria-label={t('Close')} />
            </CloseButton>
          </ModalDeleteHeader>
          <ModalBody className="justify-content-center">
            <ModalContent
              closeModal={this.closeModal}
              handleDelete={() => this.handleDelete(contactToDelete)}
            />
          </ModalBody>
        </Modal>
        {this.renderHeader({
          heading: heading.value,
          description: description.value,
        })}
        <FiltersAndTableContainer>
          <FilterContainer>
            <Column className="items-max-width">
              <div className="dropdown-companies">
                <Field
                  name="selectedCompany"
                  type="dropdown"
                  className="dropdown-companies"
                  label={t('Companies')}
                  component={Dropdown}
                  options={companies.map((item) => ({ value: item.companyName, companyId: item.companyId }))}
                  valueField="companyId"
                  valueFormatter={(option) => option && option.value}
                  onChange={(event) =>
                    this.handleCompanySelect(event)}
                />
              </div>
              <SearchContainer>
                <SearchLabel>{t('SearchUserText')}</SearchLabel>
                <TextInput
                  placeholder={t('PlaceHolderSearchText')}
                  icon={{ src: Search, alt: 'Search', onClick: () => this.getSuggestions(globalFilterValue) }}
                  input={{
                    value: (globalFilterValue || ''),
                    onChange: (event) => {
                      this.setState({ globalFilterValue: event.target.value }, () => { this.getSuggestions(globalFilterValue); });
                    },
                    onKeyDown: (event) => {
                      if (event.charCode === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.getSuggestions(globalFilterValue);
                      }
                    },
                  }}
                />
              </SearchContainer>

            </Column>
            <ActionsContainer>
              <TertiaryButton
                label={t('buttonImportExport')}
                onClick={(e) => this.handleImportExportContact(e)}
                size="small"
                className="import-export-button"
                showArrow={false}
                iconSrc={SortBlack}
                isIconLeftPosition
              />
              <TertiaryButton
                label={t('AddNewContact')}
                onClick={onClickUrl('/create-contact')}
                size="small"
                className="add-contact-button"
                showArrow={false}
                iconSrc={PlusBlack}
                isIconLeftPosition
              />
              <TertiaryButton
                label={t('ApplyFilters')}
                onClick={() => this.handleSubmitFilter()}
                size="small"
                className="apply-filters"
                showArrow={false}
                iconSrc={FilterBlack_v2}
                isIconLeftPosition
              />
            </ActionsContainer>
          </FilterContainer>
        </FiltersAndTableContainer>
        {deleteSuccess
            && (
            <Row className="justify-content-md-center">
              <Column $tablet={9}>
                <SuccessDeleteMessage>
                  {success}
                  {' '}
                  {t('SuccessDeleteMsg')}
                  ,
                  {' '}
                  {fail}
                  {' '}
                  {t('FailDeleteMsg')}
                </SuccessDeleteMessage>
              </Column>
            </Row>
            )}
        <LeftSideBar
          isOpen={filterOpen}
          toggleMenu={this.toggleFilter}
          footer={(
            <ButtonGroup>
              <TertiaryButton
                label={t('ResetFilters')}
                onClick={() => this.resetFilters()}
                showArrow={false}
                iconSrc={Reset}
                isIconLeftPosition
              />
              <PrimaryButton
                label={t('ApplyFilters')}
                onClick={() => this.handleSubmitFilter()}
              />
            </ButtonGroup>
          )}
        >
          <TitlesContainer>
            <Title>{t('ApplyFilters')}</Title>
            <SubTitle>{t('ApplyFiltersSubTitle')}</SubTitle>
          </TitlesContainer>
          <CategoryContainer>
            <FilterCategoryTitle>
              {t('FilterByContactType')}
            </FilterCategoryTitle>
            <BoxContainer
              bgColor={colors.LIGHT_GREY}
              maxWidth={BOX_CONTAINER_MAX_WIDTH}
              maxHeight={BOX_CONTAINER_MAX_HEIGHT}
            >
              <BoxInfo>
                <Field
                  name="filterContactType"
                  separator=","
                  component={Checkbox}
                  multiple
                  options={contactTypes.map((item) => ({ label: item, value: item }))}
                />
              </BoxInfo>
            </BoxContainer>
          </CategoryContainer>
        </LeftSideBar>
        {formData && formData.checked && formData.checked.filter((c) => c[1]).length !== 0
          && (
          <Row>
            <Column $tablet={4} $mobile={12} className="contacts-column">
              <TertiaryButton
                label={t('RemoveContacts')}
                onClick={() => this.openModal()}
                size="small"
                showArrow={false}
                iconSrc={RemoveBlack}
                isIconLeftPosition
              />
            </Column>
          </Row>
          )}
        <TableContainer>
          <PaginationContainer>
            <NoDataDecorator
              component={SortableTableStyled}
              data={data}
              columns={columns}
              formName={formName}
              dispatch={dispatch}
            />
          </PaginationContainer>
        </TableContainer>
      </ManageContactsForm>
    );
  }
}

ManageContacts = reduxForm({
  form: formName, // a unique identifier for this form
})(ManageContacts);

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  division: state.profile.division,
  userId: state.profile.userId,
  allContacts: state.user.allContacts,
  selectedCompany:
    state.form.formName
    && state.form.formName.values
    && state.form.formName.values.selectedCompany,
});

const mdtp = (dispatch) => ({
  putReduxAllContacts: (contactsList) => dispatch(putReduxAllContacts(contactsList)),
  putReduxAllCompanies: (companies) => dispatch(putReduxAllCompanies(companies)),
});

export default connect(
  mstp,
  mdtp,
)(ManageContacts);

ManageContacts.propTypes = {
  formData: PropTypes.object,
  division: PropTypes.string,
  userId: PropTypes.string,
  allContacts: PropTypes.arrayOf(PropTypes.object),
  putReduxAllContacts: PropTypes.func,
  putReduxAllCompanies: PropTypes.func,
  dispatch: PropTypes.func,
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      heading: PropTypes.shape({
        value: PropTypes.string,
      }),
      description: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  }),
};

CustomDropdown.propTypes = {
  openModal: PropTypes.func,
  contactId: PropTypes.string,
  contactNickname: PropTypes.string,
  contactType: PropTypes.string,
};

ModalContent.propTypes = {
  closeModal: PropTypes.func,
  handleDelete: PropTypes.func,
};
